<style>
  .dx-field-label{
    width: 100% !important;
  }
  .dx-field-value{
    width: 100% !important;
  }
  .dx-fieldset-column .dx-field{
    float: left !important;
    width: 50% !important;
    padding: 5px !important;;
  }
  .dx-fieldset-column{
    width: 100% !important;
    display: block;
    float: left;
  }

</style>
<div class="page-content bg-white">
  <!-- inner page banner -->

  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>Noticia</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <!-- Career -->
    <div class="container">
      <div class="row">
        <!-- Left part start -->
        <div class="col-md-9 m-b30">
          <h1 class="m-b20 m-t0">Formulario de Solicitud de Información</h1>

          <div class="dez-separator bg-primary"></div>


          <form #f action="your-action" (submit)="onFormSubmit($event)">
            <div class="dx-fieldsetx">
              <div class="panel panel-warning">
                <div class="panel-heading">1. DATOS DEL SOLICITANTE</div>
                <div class="panel-body">
                  <div class="dx-fieldset-header"></div>
                  <div class="dx-field">
                    <div class="dx-field-label">Nombre(s) y Apellidos</div>
                    <div class="dx-field-value">
                      <dx-text-box
                        [(value)]="data.nombre">
                        <dx-validator>
                          <dxi-validation-rule type="required" message="El campo es requerido"></dxi-validation-rule>
                          <dxi-validation-rule type="pattern" [pattern]="namePattern" message="El nombre contiene caracteres invalidos"></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </div>
                  <div class="dx-field">
                    <div class="dx-field-label">Razón Social</div>
                    <div class="dx-field-value">
                      <dx-text-box
                        [(value)]="data.razon_social">
                        <dx-validator>
                          <dxi-validation-rule type="required" message="El campo es requerido"></dxi-validation-rule>
                          <dxi-validation-rule type="pattern" [pattern]="namePattern" message="El campo contiene caracteres invalidos"></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </div>
                  <div class="dx-fieldset-column">
                    <div class="dx-field">
                      <div class="dx-field-label">Cédula de Identidad</div>
                      <div class="dx-field-value">
                        <dx-text-box
                          [(value)]="data.ci">
                          <dx-validator>
                            <dxi-validation-rule type="required" message="El campo es requerido"></dxi-validation-rule>
                            <dxi-validation-rule type="pattern" [pattern]="ciPattern" message="Se permiten solo números"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>

                      </div>
                    </div>
                    <div class="dx-field">
                      <div class="dx-field-label">Expedido en</div>
                      <div class="dx-field-value">
                        <dx-select-box
                          [dataSource]="departamentos"
                          valueExpr="ID"
                          displayExpr="sigla"
                          placeholder=""
                          [(value)]="data.exp">
                          <dx-validator>
                            <dxi-validation-rule type="required" message="Departamento es requerido"></dxi-validation-rule>
                          </dx-validator>
                        </dx-select-box>
                      </div>
                    </div>
                  </div>
                  <div class="dx-fieldset-column">
                    <div class="dx-field">
                      <div class="dx-field-label">Representante Legal</div>
                      <div class="dx-field-value">
                        <dx-text-box
                          [(value)]="data.representante">
                          <dx-validator>
                            <dxi-validation-rule type="pattern" [pattern]="namePattern" message="Se permiten solo números"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </div>
                    <div class="dx-field">
                      <div class="dx-field-label">N° de Testimonio</div>
                      <div class="dx-field-value">
                        <dx-text-box
                          [(value)]="data.testimonio">
                          <dx-validator>
                            <dxi-validation-rule type="pattern" [pattern]="servidoresPattern" message="Se permiten solo números"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </div>
                  </div>
                  <div class="dx-fieldset-column">
                    <div class="dx-field">
                      <div class="dx-field-label">Correo Eletrónico</div>
                      <div class="dx-field-value">
                        <dx-text-box
                          [(value)]="data.email">
                          <dx-validator>
                            <dxi-validation-rule type="email" message="Correo invalido"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </div>
                    <div class="dx-field">
                      <div class="dx-field-label">Teléfono y/o Celular</div>
                      <div class="dx-field-value">
                        <dx-text-box
                          [(value)]="data.telefono">
                          <dx-validator>
                            <dxi-validation-rule type="required" message="El campo es requerido"></dxi-validation-rule>
                            <dxi-validation-rule type="pattern" [pattern]="phonePattern" message="Se permiten solo números"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </div>
                  </div>

                  <div class="dx-fieldset-column">
                    <div class="dx-field">
                      <div class="dx-field-label">Departamento</div>
                      <div class="dx-field-value">
                        <dx-select-box
                          [dataSource]="departamentos"
                          valueExpr="ID"
                          displayExpr="Nombre"
                          placeholder="Select a product..."
                          [(value)]="data.departamento">
                          <dx-validator>
                            <dxi-validation-rule type="required" message="Departamento es requerido"></dxi-validation-rule>
                          </dx-validator>
                        </dx-select-box>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel panel-warning">
                <div class="panel-heading">2.DESCRIPCIÓN PRECISA DE LA INFORMACIÓN SOLICITADA</div>
                <div class="panel-body">
                  <div class="dx-fieldset-header"></div>
                  <div class="dx-field">
                    <div class="dx-field-label"></div>
                    <div class="dx-field-value">
                      <dx-text-area
                        height="90"
                        maxLength="1000"
                        [(value)]="data.descripcion">
                        <dx-validator>
                          <dxi-validation-rule type="required" message="El campo es requerido"></dxi-validation-rule>
                          <dxi-validation-rule type="pattern" [pattern]="servidoresPattern" message="El campo es requerido"></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-area>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel panel-warning">
                <div class="panel-heading">3.EXPLIQUE EL MOTIVO DE LA INFORMACIÓN</div>
                <div class="panel-body">
                  <div class="dx-fieldset-header"></div>
                  <div class="dx-field">
                    <div class="dx-field-label"></div>
                    <div class="dx-field-value">
                      <dx-text-area
                        height="90"
                        maxLength="1000"
                        [(value)]="data.motivo">
                        <dx-validator>
                          <dxi-validation-rule type="required" message="El campo es requerido"></dxi-validation-rule>
                          <dxi-validation-rule type="pattern" [pattern]="servidoresPattern" message="El campo es requerido"></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-area>
                    </div>
                  </div>
                  <re-captcha (captchaResponse)="handleCorrectCaptcha($event)" site_key="6LfkSlIUAAAAAFh-ki_ACDFrB2nsIfI3xldetZh8"></re-captcha>
                </div>
              </div>

            </div>

            <dx-validation-summary id="summary"></dx-validation-summary>

            <dx-button
              id="button"
              text="Enviar"
              [disabled]="vare"
              type="success"
              [useSubmitBehavior]="true">
            </dx-button>
          </form>
        </div>
        <!-- Left part start END -->
        <!-- Right part start -->
        <div class="col-md-3">
          <div class="widget bg-white recent-posts-entry">
            <h4 class="widget-title">Documentos importantes</h4>
            <div class="widget-post-bx">
              <ng-container *ngFor="let item of documentos">
                <div class="widget-post clearfix">
                  <div class="dez-post-media"> <img src="{{domain}}{{item.imagen}}" alt="" width="200" height="143"> </div>
                  <div class="dez-post-info">
                    <div class="dez-post-header">
                      <h6 class="post-title">
                        <div *ngIf="item.url>0;then uno else dos"></div>
                        <ng-template #uno>
                          <a routerLink="/content/{{item.url}}">{{item.titulo}}</a>
                        </ng-template>
                        <ng-template #dos>
                          <a target="_blank" href="{{domain}}/{{item.url}}">{{item.titulo}}</a>
                        </ng-template>
                      </h6>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- Right part start END -->
      </div>
    </div>
    <!-- Career END -->
  </div>
  <!-- contact area END -->
</div>



// WEBPACK FOOTER //
// ./src/app/layouts/frm-solicitud/frm-solicitud.component.html